import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Box, Button } from "@mui/material"
import { getDoc, updateDoc, doc, collection, DocumentSnapshot } from "firebase/firestore"
import { db } from "../firebase"
import { toast } from 'react-toastify'
import dayjs from "dayjs"
import { setIndividualStatus } from "./admin/lib/common"
import { StepFormConfirm } from "./lib/StepFormConfirm"
import { FormProps } from "./lib/StepForm"

const IndividualRegistrationConfirm = () => {
  const urlParams = useParams<{ individualId: string }>()
  const [values, setValues] = useState<Record<string, string>>({})
  const [forms, setForms] = useState<Array<FormProps>>([])
  const navigate = useNavigate()

  useEffect(() => {
    getDoc(doc(collection(db, 'forms'), 'individual')).then((_: DocumentSnapshot) => {
      _.exists() && setForms(_.data().conf.filter((form: FormProps) => form.isHunterElements))
    })
    const storageValues = sessionStorage.getItem('individual')
    storageValues && setValues(JSON.parse(storageValues))
  }, [])

  const onSave = () => {
    const individualDoc = doc(collection(db, 'individuals'), urlParams.individualId)
    updateDoc(individualDoc, setIndividualStatus({ ...values, updatedAt: dayjs().format('YYYY/MM/DD HH:mm') }))
      .then(() => {
        toast.success("個体情報を登録しました")
        sessionStorage.removeItem('individual')
        navigate(`/individuals/${urlParams.individualId}/arrival/regist`)
      }).catch(e => {
        toast.error(e)
      })
  }

  return (
    <Box>
      <StepFormConfirm forms={forms} values={values}/>
      <Box mt={2} display="flex" justifyContent="center">
        <Button variant="outlined" onClick={() => navigate(`/individuals/${urlParams.individualId}/regist`)}>戻る</Button>
        <Button variant="contained" onClick={onSave} sx={{ ml: 2 }}>登録</Button>
      </Box>
    </Box>
  )
}

export default IndividualRegistrationConfirm
